<div id="datePicker" style="margin-bottom: 5px; display: flex; justify-content: space-between; margin-top: 5px;">
  <span>
    <label for="startDate" style="margin-top: auto;">Start Date: &nbsp;</label>
    <p-datepicker id="startDate" [(ngModel)]="startDate" [showIcon]="true"
      (ngModelChange)="onDateChange()"></p-datepicker>

    <span style="margin-left: 15px;">
      @if (timerPaused) {
      <i class="fa fa-play" (click)="startTimer()"></i>
      }
      @if (!timerPaused) {
      <i class="fa fa-pause" (click)="pauseTimer()"></i>
      }
      {{timeLeft | time}} until refresh
    </span>
  </span>
  <span>
    <p-button type="button" label="Notify All Customers" severity="secondary" [disabled]="!canDrag"
      (click)="showDialog(bucketListDayList)"></p-button>
  </span>
</div>

@if (displayScheduleDialog) {
<p-dialog header="Schedule" [(visible)]="displayScheduleDialog" [modal]="true" [resizable]="false" [baseZIndex]="10000"
  appendTo="body">
  <div class="form-group">
    {{message}}
  </div>
  <div class="form-group" style="margin-top: 5px">
    <p-button type="button" type="submit" (click)="scheduleDays()" label="Yes"></p-button>&nbsp;
    <p-button type="button" (click)="displayScheduleDialog=false" label="No" severity="info"></p-button>
  </div>
</p-dialog>
}

@if (displayErrorScheduleDialog) {
<p-dialog header="Schedule" [(visible)]="displayErrorScheduleDialog" [modal]="true" [resizable]="false"
  [baseZIndex]="10000" appendTo="body">
  <form [formGroup]="commentForm">
    <div class="form-group">
      {{message}}
      <textarea pInputTextarea formControlName="errorComment" class="form-control" [required]="true"
        style="width: 100%;" autoResize="autoResize"
        placeholder="Explain why you are still proceeding despite the errors..."></textarea>
    </div>
    <div class="form-group" style="margin-top: 5px">
      <p-button type="button" type="submit" [disabled]="commentForm.invalid" (click)="scheduleDays()"
        label="Yes"></p-button>&nbsp;
      <p-button type="button" (click)="displayErrorScheduleDialog=false" label="No" severity="info"></p-button>
    </div>
  </form>
</p-dialog>
}

<p-dialog header="Confirmation" [(visible)]="displayConfirmationDialog" [modal]="true" [resizable]="false"
  [baseZIndex]="10000" appendTo="body">
  <div>
    {{confirmMessage}}
  </div>
  <div class="footer">
    <p-button type="button" (click)="displayConfirmationDialog=false" label="Ok" severity="info"></p-button>
  </div>
</p-dialog>

<div id="twoDayCalendar" class="p-grid" style="height: 91%;">
  <p-card id="dayOne" class="p-col dayCard" cdkDropList [cdkDropListDisabled]="!canDrag"
    [cdkDropListData]="bucketListDayList[0].bucketList" cdkDropListConnectedTo="dayTwo"
    (cdkDropListDropped)="drop($event)">
    <p-header>
      @if (canDrag) {
      <span style="float: left;">
          <p-datepicker [minDate]="today" class="only-icon rescheule-calendar" [(ngModel)]="rescheduleDate"
            [showIcon]="true" (ngModelChange)="rescheduleDay(bucketListDayList[0])"></p-datepicker>
        </span>
      }
      {{bucketListDayList[0].day | date: 'EEEE M/d' | uppercase}}
      @if (canDrag) {
        <i style="float: right;" pTooltip="Add New Crew" tooltipPosition="bottom" class="pi pi-plus"
          (click)="addNewCrew(bucketListDayList[0])"></i>
      }
      <p-button class="scheduleButton" severity="info" type="button" label="Notify Customers" [disabled]="!canDrag"
        (click)="showDialog([bucketListDayList[0]])"></p-button>
    </p-header>
    @if (unavailableEquipment && unavailableEquipment.length > 0 && unavailableEquipment[0].length > 0) {
    <app-unavailable-equipment-and-employees [bigEquipment]="unavailableEquipment[0]"
      [bigEmployees]="unavailableEmployees[0]" [type]="isWellness ? 'wellness' : 'work'">
    </app-unavailable-equipment-and-employees>
    }
    @for (item of bucketListDayList[0].bucketList; track item) {
    <div style="clear:both;" cdkDrag [cdkDragDisabled]="disableDrag(item)">
      <app-scheduled-item-bucket-card (isInitialized)="onNewBucket($event)" class="scheduled-item" [bucket]="item" [canDrag]="canDrag"
        (needsValidated)="validateDay(bucketListDayList[0].day)" (dragStartEvent)="woDragStart($event, item.id)"
        (dragEndEvent)="woDragEnd()" (taskDragStartEvent)="taskDraggedStart($event)"
        (taskDragEndEvent)="taskDraggedEnded()" [isWellness]="isWellness"
        [isWork]="isWork"></app-scheduled-item-bucket-card>
    </div>
    }
  </p-card>
  <p-card id="dayTwo" class="p-col dayCard" cdkDropList [cdkDropListDisabled]="!canDrag"
    [cdkDropListData]="bucketListDayList[1].bucketList" cdkDropListConnectedTo="dayOne"
    (cdkDropListDropped)="drop($event)">
    <p-header>
      @if (canDrag) {
        <span style="float: left;">
          <p-datepicker [minDate]="today" class="only-icon rescheule-calendar" [(ngModel)]="rescheduleDate"
            [showIcon]="true" (ngModelChange)="rescheduleDay(bucketListDayList[1])"></p-datepicker>
        </span>
      }
      {{bucketListDayList[1].day | date: 'EEEE M/d' | uppercase}}
      @if (canDrag) {
        <i style="float: right;" pTooltip="Add New Crew" tooltipPosition="bottom" class="pi pi-plus"
          (click)="addNewCrew(bucketListDayList[1])"></i>
      }
      <p-button class="scheduleButton" severity="info" type="button" label="Notify Customers" [disabled]="!canDrag"
        (click)="showDialog([bucketListDayList[1]])"></p-button>
    </p-header>
    @if (unavailableEquipment && unavailableEquipment.length > 0 && unavailableEquipment[1].length > 0) {
    <app-unavailable-equipment-and-employees [bigEquipment]="unavailableEquipment[1]"
      [bigEmployees]="unavailableEmployees[1]" [type]="isWellness ? 'wellness' : 'work'">
    </app-unavailable-equipment-and-employees>
    }
    @for (item of bucketListDayList[1].bucketList; track item) {
    <div cdkDrag [cdkDragDisabled]="disableDrag(item)">
      <app-scheduled-item-bucket-card (isInitialized)="onNewBucket($event)" class="scheduled-item" [bucket]="item" [canDrag]="canDrag"
        (needsValidated)="validateDay(bucketListDayList[1].day)" (dragStartEvent)="woDragStart($event, item.id)"
        (dragEndEvent)="woDragEnd()" (taskDragStartEvent)="taskDraggedStart($event)"
        (taskDragEndEvent)="taskDraggedEnded()" [isWellness]="isWellness"
        [isWork]="isWork"></app-scheduled-item-bucket-card>
    </div>
    }
  </p-card>
</div>